import { useEffect, useState } from "react";
import usePopupMsg from "../../hooks/usePopupMsg";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const Popup = () => {
  const { isOpen, msg, label, close } = usePopupMsg();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false); 
        setTimeout(() => {
          close();
        }, 300); 
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, close]);

  const isSuccess = label === "success";

  return (
    <div
      className={`fixed top-16 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ease-in-out
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-10"}
      `}
    >
      {(msg || isOpen) && (
        <div
          className={`flex items-center gap-3 px-3 py-2 rounded-xl shadow-lg text-white
            ${isSuccess ? "bg-green-600" : "bg-rose-600"}
          `}
        >
          {isSuccess ? (
            <FaCheckCircle className="text-white text-xl" />
          ) : (
            <FaTimesCircle className="text-white text-xl" />
          )}
          <p className="text-sm font-medium">{msg}</p>
        </div>
      )}
    </div>
  );
};

export default Popup;
